module.exports = __webpack_public_path__ + "static/media/infoJumbo2.3d795742.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/gressel/images/infoJumbo2.png
// module id = 540
// module chunks = 0